export default "__VITE_ASSET__Bevkvb$W__"